(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["massetani-filters"] && !Shopify.designMode) return;
  try {
    (() => {
  const media = window.matchMedia('(min-width: 768px)');
  function mountFilters() {
    const panel = document.querySelector('[data-mc-filters]');
    const sidebar = document.querySelector('.sidebar_small .sidebar');
    const main = document.querySelector('.main_content');
    if (!panel || !sidebar || !main) return;
    const target = media.matches ? sidebar : main;
    if (panel.parentElement !== target) target.prepend(panel);
    if (panel.dataset.mode !== String(media.matches)) {
      panel.querySelector('details').open = media.matches;
      panel.dataset.mode = String(media.matches);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountFilters);
  else mountFilters();
  media.addEventListener('change', mountFilters);
  document.addEventListener('shopify:section:load', mountFilters);
})();
  } catch(e) { console.error(e); }
})();

})();
